module.exports = __webpack_public_path__ + "img/plus.e144ff40.svg";